export enum SettingsSelectedTab {
  Profile = "Profile",
  People = "People",
  Departments = "Departments",
  Categories = "Categories",
  BankAccount = "Bank Account",
  CustomFields = "Custom Fields",
}
